var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 14.9995L17.1666 15.9112C16.7245 16.3946 16.1251 16.6662 15.5001 16.6662C14.8751 16.6662 14.2757 16.3946 13.8337 15.9112C13.391 15.4288 12.7916 15.1579 12.1668 15.1579C11.542 15.1579 10.9426 15.4288 10.5 15.9112M3 16.6662H4.39545C4.8031 16.6662 5.00693 16.6662 5.19874 16.6202C5.3688 16.5793 5.53138 16.512 5.6805 16.4206C5.84869 16.3175 5.99282 16.1734 6.28107 15.8852L16.75 5.4162C17.4404 4.72585 17.4404 3.60656 16.75 2.9162C16.0597 2.22585 14.9404 2.22585 14.25 2.9162L3.78105 13.3852C3.4928 13.6734 3.34867 13.8175 3.2456 13.9857C3.15422 14.1348 3.08688 14.2974 3.04605 14.4675C3 14.6593 3 14.8631 3 15.2708V16.6662Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.bb9bce8ccc3746bd23b1f868e625d42b.svg";
export { ForwardRef as ReactComponent };